import Vue from 'vue'
import Router from 'vue-router'

// Shared
// import Completed from '@/components/shared/Completed'
// import Aborted from '@/components/shared/Aborted'

// Tasks
// import DigitSpanForwards from '@/components/Tasks/DigitSpanForwards/Root'
// import DigitSpanBackwards from '@/components/Tasks/DigitSpanBackwards/Root'
// import Coding from '@/components/Tasks/Coding/Root'
// import PatternSeparationTask from '@/components/Tasks/PatternSeparationTask/Root'
// import Attention from '@/components/Tasks/Attention/Root'
// import ComplexReactionTime from '@/components/Tasks/ComplexReactionTime/Root'
// import VerbalMemory from '@/components/Tasks/VerbalMemory/Root'
// import VisualMemory from '@/components/Tasks/VisualMemory/Root'

// Dashboard
const Dashboard = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/Root'), 'dash')
  })
}

// SHARED COMPONENTS
const Completed = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/shared/Completed'), 'shared')
  })
}

// SHARED COMPONENTS
const Error = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Error'), 'error')
  })
}

const Aborted = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/shared/Aborted'), 'shared')
  })
}

// TASKS
const DigitSpanForwards = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Tasks/DigitSpanForwards/Root'))
  })
}
const DigitSpanBackwards = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Tasks/DigitSpanBackwards/Root'))
  })
}
const Coding = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Tasks/Coding/Root'))
  })
}
const PatternSeparationTask = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Tasks/PatternSeparationTask/Root'))
  })
}
const SimpleReactionTime = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Tasks/SimpleReactionTime/Root'))
  })
}
const ComplexReactionTime = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Tasks/ComplexReactionTime/Root'))
  })
}
const VerbalMemory = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Tasks/VerbalMemory/Root'))
  })
}
const VisualMemory = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Tasks/VisualMemory/Root'))
  })
}
const MST = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Tasks/MST/Root'))
  })
}

const PictureVocabularyTask = resolve => {
  require.ensure([], () => {
    resolve(require('@/components/Tasks/PictureVocabularyTask/Root'))
  })
}

const iqtest = resolve => {
  require.ensure([], () => {
    resolve(require('@/components/Tasks/iqt/Root'))
  })
}

const PatternRecognitionTest = resolve => {
  require.ensure([], () => {
    resolve(require('@/components/Tasks/ptr/Root'))
  })
}
/*
const AudioCheck = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/AudioCheck'), 'dash')
  })
}
const Consent = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/Consent'), 'dash')
  })
}
const Done = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/Done'), 'dash')
  })
}
const Feedback = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/Feedback'), 'dash')
  })
}
const Rules = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/Rules'), 'dash')
  })
}
const Task = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Dashboard/Task'), 'dash')
  })
}
*/

const Login = resolve => {
  // The empty array is for specifying other dependencies that need to be loaded.
  require.ensure([], () => {
    resolve(require('@/components/Login'))
  })
}

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '*',
      name: 'index',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/error',
      name: 'error',
      component: Error
    },
    {
      path: '/dash',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/dsf',
      name: 'DigitSpanForwards',
      component: DigitSpanForwards
    },
    {
      path: '/dsb',
      name: 'DigitSpanBackwards',
      component: DigitSpanBackwards
    },
    {
      path: '/cod',
      name: 'Coding',
      component: Coding
    },
    {
      path: '/srt',
      name: 'SimpleReactionTime',
      component: SimpleReactionTime
    },
    {
      path: '/crt',
      name: 'ComplexReactionTime',
      component: ComplexReactionTime
    },
    {
      path: '/pst',
      name: 'PatternSeparationTask',
      component: PatternSeparationTask
    },
    {
      path: '/mst',
      name: 'MST',
      component: MST
    },
    {
      path: '/vm',
      name: 'VerbalMemory',
      component: VerbalMemory
    },
    {
      path: '/vismem',
      name: 'VisualMemory',
      component: VisualMemory
    },
    {
      path: '/aborted',
      name: 'Aborted',
      component: Aborted
    },
    {
      path: '/completed',
      name: 'completed',
      component: Completed
    },
    {
      path: '/pvt',
      name: 'pictureVocabulary',
      component: PictureVocabularyTask
    },
    {
      path: '/mat',
      name: 'MatrixTest',
      component: iqtest
    },
    {
      path: '/ptr',
      name: 'PatternRecognition',
      component: PatternRecognitionTest
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js